import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { Typography } from 'foundations-library/components'

const useStyles = makeStyles(theme => {
    return {
        root: {
            backgroundColor: theme.palette.grey[100],
            padding: '15px',
            borderWidth: '0 0 1px 0',
            borderColor: theme.palette.grey[300],
            borderStyle: 'solid'
        }

    }
})

/**
 *
 */
const GoBack = ({ title }: { title?: string }) => {
    const classes = useStyles()

    return (
        <div className={classes.root}>
            <Typography variant='h8' color='neutral-900'>{title}</Typography>
        </div>
    )
}

export default GoBack
